/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconPauseLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 12 12">
    <><g>
    <path d="M8.1,1h1.4C10.4,1,11,1.6,11,2.2v7.5c0,0.7-0.6,1.2-1.4,1.2H8.1c-0.8,0-1.4-0.6-1.4-1.2V2.2C6.7,1.6,7.4,1,8.1,1z M9.6,9.8 V2.2H8.1v7.5H9.6z" />
</g>
<g>
    <path d="M2.4,1h1.4c0.8,0,1.4,0.6,1.4,1.2v7.5c0,0.7-0.6,1.2-1.4,1.2H2.4C1.6,11,1,10.4,1,9.8V2.2C1,1.6,1.6,1,2.4,1z M3.9,9.8V2.2 H2.4v7.5H3.9z" />
</g></>
  </Icon>
);
};

IconPauseLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTIgMTIiPgogIDxnPgogICAgPHBhdGggZD0iTTguMSwxaDEuNEMxMC40LDEsMTEsMS42LDExLDIuMnY3LjVjMCwwLjctMC42LDEuMi0xLjQsMS4ySDguMWMtMC44LDAtMS40LTAuNi0xLjQtMS4yVjIuMkM2LjcsMS42LDcuNCwxLDguMSwxeiBNOS42LDkuOCBWMi4ySDguMXY3LjVIOS42eiIvPgogIDwvZz4KICA8Zz4KICAgIDxwYXRoIGQ9Ik0yLjQsMWgxLjRjMC44LDAsMS40LDAuNiwxLjQsMS4ydjcuNWMwLDAuNy0wLjYsMS4yLTEuNCwxLjJIMi40QzEuNiwxMSwxLDEwLjQsMSw5LjhWMi4yQzEsMS42LDEuNiwxLDIuNCwxeiBNMy45LDkuOFYyLjIgSDIuNHY3LjVIMy45eiIvPgogIDwvZz4KPC9zdmc+";
IconPauseLineComponent.Content = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12 12">
  <g>
    <path d="M8.1,1h1.4C10.4,1,11,1.6,11,2.2v7.5c0,0.7-0.6,1.2-1.4,1.2H8.1c-0.8,0-1.4-0.6-1.4-1.2V2.2C6.7,1.6,7.4,1,8.1,1z M9.6,9.8 V2.2H8.1v7.5H9.6z"/>
  </g>
  <g>
    <path d="M2.4,1h1.4c0.8,0,1.4,0.6,1.4,1.2v7.5c0,0.7-0.6,1.2-1.4,1.2H2.4C1.6,11,1,10.4,1,9.8V2.2C1,1.6,1.6,1,2.4,1z M3.9,9.8V2.2 H2.4v7.5H3.9z"/>
  </g>
</svg>`;

const IconPauseLine = styled(IconPauseLineComponent)``;

export default IconPauseLine;
